export default "__VITE_ASSET__OObXtKmm__"